"use client";
import React, { useMemo } from "react";
import Image from "next/image";
import CustomNavLink from "../CustomLink/CustomNavLink";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import useIsMobile from "@/hooks/useMobile";
import useImageUrlModifier from "@/lib/useImageUrlModifier";

const Banner = ({ banner }) => {
  const isMobile = useIsMobile(1280);
  const sortedBanners = useMemo(
    () => [...banner]?.sort((a, b) => a?.bannerIndex - b?.bannerIndex),
    [banner]
  );

  const modifyImageUrl = useImageUrlModifier();

  const swiperParams = useMemo(
    () => ({
      modules: [Navigation, Autoplay],
      grabCursor: true,
      slidesPerView: 1,
      loop: true,
      navigation: !isMobile && {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    }),
    [isMobile]
  );

  return (
    <>
      {sortedBanners?.length > 0 && (
        <div className="relative w-full">
          <Swiper {...swiperParams} className="mySwiper">
            {sortedBanners?.map((item, index) => {
              const isFirst = index === 0;
              return (
                <SwiperSlide key={item?._id} style={{
                  width: "100%",
                  height: "auto",
                  paddingBottom: isMobile ? "56.25%" : "23.33%", // 16:9 for mobile, 30:7 for desktop
                }}>
                  <CustomNavLink href={item?.productUrl} style={{
                    position: "relative",
                    width: "100%",
                    height: "auto",
                    paddingBottom: isMobile ? "56.25%" : "23.33%", // 16:9 for mobile, 30:7 for desktop
                  }}>

                    <Image
                      src={modifyImageUrl(item?.bannerUrl, 1920, 448) || "/images/dummy-image-square.jpg"}
                      fill
                      alt={`Banner image ${item?._id}`}
                      // Only the first slide is the LCP — priority + eager only for it.
                      // Marking every slide priority preloads all of them and wastes mobile bandwidth.
                      priority={isFirst}
                      sizes="100vw"
                      quality={75}
                      blurDataURL="/images/dummy-image-square.jpg"
                      placeholder="blur"
                      loading={isFirst ? "eager" : "lazy"}
                      style={{
                        aspectRatio: isMobile ? "16 / 9" : "30 / 7",
                        objectFit: "cover",
                      }}
                    />
                  </CustomNavLink>
                </SwiperSlide>
              );
            })}
          </Swiper>

          {!isMobile && (
            <>
              <button
                className="swiper-button-prev"
                style={buttonStyles}
                aria-label="Previous slide"
              >
              </button>
              <button
                className="swiper-button-next"
                style={buttonStyles}
                aria-label="Next slide"
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

const buttonStyles = {
  color: "#AC7529",
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 10,
  cursor: "pointer",
  margin: "0 1rem",
  transform: "translateY(-50%) scale(0.8)", // Added scale down by 20%
};

export default React.memo(Banner);
